<div class="errors-warp" [ngClass]="{'isErrorMessage':isUser$()&& (invalidCurrentStep$ | async) &&(isVisitedStep$() || isShowError$())}">

    <div class="error-requierd none-in-mobile2" *ngIf="isUser$()&& (invalidCurrentStep$ | async) &&(isVisitedStep$() || isShowError$())">
        <img src="assets\images\steps\mark-bad.svg">
        <span translate>mandatoryQuestionsExist</span>
    </div>
</div>
<div class="board" *ngIf="currentStep$ |async as step" [ngClass]="isPreview?'empty-top':''">
    <que-definitions-in-board [isEdit]="!isPreview"></que-definitions-in-board>
    <div class="box" *ngFor="let q of step.questions, let i=index, trackBy: trackByQuestionId"
        [ngClass]="{'foloow-up':q.parentFollowUpQuestionId!=null && isPreview && !isUser$()}">
        <div class="follow-up-title" *ngIf="q.parentFollowUpQuestionId!=null && !isUser$() && isPreview">
            <p class="no-warp" translate>followQuestion.follow-to-option</p>
            <p class="option">
                {{getOptionToQuestionById(q.parentFollowUpQuestionId,q.followAnswerOptionItemGuid)}}</p>
        </div>
        <que-warp-question-display class="question-form" [question]="q"
            [isPreview]="isPreview" [viewAnswer]="viewAnswer"></que-warp-question-display>
    </div>
    <div class="warp-btn">
        <div class="btn" *ngIf="currentStepIndex$()??0>0" [style.background]="mainColor$ | async" (click)="prev()">
            <div class="text" translate>
                btns.prev</div>
        </div>
        <div class="btn" *ngIf="!((stepsLength$ | async) == (currentStepIndex$() ?? 0) + 1)"
            [style.background]="mainColor$ | async" (click)="next()">
            <div class="text" translate>
                btns.next</div>
        </div>
    </div>
</div>